module.exports = __webpack_public_path__ + "img/curly-logo.a66ebbe9.svg";